import React, { useEffect, useRef } from 'react';
import { Logger } from '../services/historyService';

interface SecurityMonitorProps {
  user: any;
  orgId: string;
  activeTab: string;
}

export const SecurityMonitor: React.FC<SecurityMonitorProps> = ({ user, orgId, activeTab }) => {
  const lastLogRef = useRef<number>(0);

  useEffect(() => {
    if (!user || !orgId) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // PrintScreen key is tricky in modern browsers, but some browsers still report it
      // Standard key name is 'PrintScreen'
      if (e.key === 'PrintScreen' || (e.ctrlKey && e.key === 'p')) {
        // Prevent frequent logging if multiple keys are pressed
        const now = Date.now();
        if (now - lastLogRef.current > 5000) {
           Logger.logSecurity(orgId, 'SCREENSHOT', activeTab);
           lastLogRef.current = now;
        }
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        // User switched tabs or minimized
        const now = Date.now();
        if (now - lastLogRef.current > 10000) { // Throttle tab switches
          Logger.logSecurity(orgId, 'TAB_SWITCH', activeTab);
          lastLogRef.current = now;
        }
      }
    };

    const handleBlur = () => {
      // Often triggered when opening snipping tool
      const now = Date.now();
      if (now - lastLogRef.current > 5000) {
        Logger.logSecurity(orgId, 'TAB_SWITCH', activeTab + ' (Blur/Potential Clip)');
        lastLogRef.current = now;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleBlur);
    };
  }, [user, orgId, activeTab]);

  return null; // Invisible monitor
};
